import classnames from 'classnames';
import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { twMerge } from 'tailwind-merge';

type FormCheckboxProps = FieldRenderProps<string, HTMLElement, string> & {
  labelText?: string;
};

const FormCheckbox: FC<FormCheckboxProps> = ({
  input,
  labelText,
  labelClassName,
  meta: { touched, error },
  disabled,
  ...otherProps
}) => {
  return (
    <div className="block pb-5">
      <div className="mt-2">
        <label
          htmlFor={input.name}
          className={classnames(
            twMerge('inline-flex items-center', labelClassName),
            {
              'sr-only': !labelText,
            },
          )}
        >
          <input
            id={input.name}
            type="checkbox"
            className={classnames(
              'size-4 rounded border-gray-300 text-sky-900 focus:ring-2 focus:ring-sky-800',
              {
                'border-red-800': touched && error,
              },
            )}
            autoComplete="off"
            disabled={disabled}
            {...input}
            {...otherProps}
          />
          <span className={classnames('ml-2', { 'opacity-50': disabled })}>
            {labelText || input.name}
          </span>
        </label>
        {touched && error && (
          <span className="text-xs text-red-800">{error}</span>
        )}
      </div>
    </div>
  );
};

export default FormCheckbox;
